require('./loanSettlementsView.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require("react-router-dom");
//@actions
const {
    requestLoanSettlements,
    setFilters,
    clearFitlers
} = require('../../actions/loanSettlements');
const collectiveActions = require('actions/collectives');
// @ components
const LoanHeader = require('../../components/loansAndMortgages/loans/loanHeader/loanHeader');
const LoanSettlements = require('../../components/loansAndMortgages/loans/loanSettlements/loanSettlements');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
// @ commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
// @constants
const { MULTICHANNEL_UI_COMPONENT } = require('constants/index');

class LoanSettlementsView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { requestLoanSettlements, match: { params: { loanId } }, immLoans, getCollectiveInfo } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);

        if (immLoan && !immLoan.get('isOldLoan') && !immLoan.get('isRestrictedLoan')) {
            const productType = {
                type: immLoan.get('product'),
                subType: immLoan.get('productSubType'),
                standard: immLoan.get('productStandard')
            };

            requestLoanSettlements(loanId);
            getCollectiveInfo([productType], MULTICHANNEL_UI_COMPONENT);
        } else {
            this.props.history.push('myprofile/loans-mortgages');
        }
    }

    componentWillUnmount() {
        this.props.clearFitlers();
    }

    buildBreadcrumb(immLoan) {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: `/myprofile/loans-mortgages`
            },
            {
                text: immLoan.get('alias'),
                url: `/myprofile/loans-mortgages/loans/${immLoan.get('loanId')}`
            },
            {
                text: formatText('breadcrumb-settlements')
            }
        ];
    }

    render() {
        const { immLoans, immLoanSettlements, match } = this.props;
        const { params: { loanId } } = match;
        const immLoan = immLoans.getIn(['byId', loanId], false);

        let breadcrumb;

        if (immLoan && !immLoan.get('isOldLoan') && !immLoan.get('isRestrictedLoan')) {
            const immFilters = immLoanSettlements.get('filters');
            const headerTitle = toCamelCase(immLoan.get('alias'));
            breadcrumb = this.buildBreadcrumb(immLoan);
            return (
                <article className="loan-settlements-view">
                    <LoanHeader
                        immLoan={immLoan}
                        breadcrumbConfig={breadcrumb}
                        title={headerTitle}
                    />
                    <section className="loan-settlements-view__body">
                        <div className="row no-outside-gutter">
                            <div className="col-xs-9">
                                <LoanSettlements
                                    immLoan={immLoan}
                                    immLoanSettlements={immLoanSettlements}
                                    immFilters={immFilters}
                                    loanId={loanId}
                                />
                            </div>
                            <div className="col-xs-3">
                                <CommercialAds path={match.path} type="banner-b" />
                            </div>
                        </div>
                    </section>
                </article>
            );
        }

        return null;
    }
}

LoanSettlementsView.propTypes = {
    getCollectiveInfo: PropTypes.func.isRequired,
    immLoans: PropTypes.object.isRequired,
    clearFitlers: PropTypes.func.isRequired,
    immLoanSettlements: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    productAds: PropTypes.object,
    requestLoanSettlements: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(connect(state => ({
    immLoans: state.loans,
    immLoanSettlements: state.loanSettlements
}), {
        clearFitlers,
        getCollectiveInfo: collectiveActions.getCollectiveInfo,
        requestLoanSettlements,
        setFilters
    })(LoanSettlementsView));
